import React from 'react';
import "../css/bootstrap.css"
import "../css/app.css"
const project1 = require("../assets/project1.png")
const project2 = require("../assets/project2.png")
const project3 = require("../assets/project31.png")
const project5 = require("../assets/project5.png")
const project4 = require("../assets/project4.png")

export const Projects = () => {
    return(
        <div className="container black projects">
            <hr></hr>
            <h1 className="projecttitle">My Projects</h1>
            <div className="row d-flex justify-content-center projectrow">
                <div className="col-lg-4 col-md-12 d-flex justify-content-center align-items-center project">
                    <img className="projectimg" src={project1} alt="nothing"></img>
                    <a href="https://bridge007.netlify.app/" target="_blank" rel="noopener noreferrer">
                    <div className="d-flex flex-column justify-content-center align-items-center">
                        <h1>Bridge</h1>
                        <p>A web application for the 4-player card game 'Bridge', build with React, SocketIO and Node.</p>
                    </div>
                    </a>
                </div>
                <div className="col-lg-4 col-md-12 d-flex flex-column justify-content-center align-items-center project">
                    <img className="projectimg" src={project2} alt="nothing"></img>
                    <a href="https://github.com/hemanthram/hotdog-not-hotdog" target="_blank" rel="noopener noreferrer">
                    <div className="d-flex flex-column justify-content-center align-items-center">
                        <h1>Hotdog or Not ?</h1>
                        <p>Inspired from Jian Yang (Silicon Valley), a hotdog detector which classifies given images as 'Hotdog or Not'. 
                            Used AlexNet architecture and achieved test accuracy of 80%.
                        </p>
                    </div>
                    </a>
                </div>
                <div className="col-lg-4 col-md-12 d-flex flex-column justify-content-center align-items-center project">
                    <img className="projectimg" src={project3} alt="nothing"></img>
                    <a href="https://hopeful-swanson-4e1211.netlify.app/" target="_blank" rel="noopener noreferrer">
                    <div className="d-flex flex-column justify-content-center align-items-center">
                        <h1>TicTacToe</h1>
                        <p>A web application for the classic game of TicTacToe.</p>
                    </div>
                    </a>
                </div>
                <div className="col-lg-4 col-md-12 d-flex flex-column justify-content-center align-items-center project">
                    <img className="projectimg" src={project4} alt="nothing"></img>
                    <a href="https://github.com/hemanthram/cricket_highlights_detector" target="_blank" rel="noopener noreferrer">
                    <div className="d-flex flex-column justify-content-center align-items-center">
                        <h1 style={{textAlign:"center"}}>Highlights Detector</h1>
                        <p>Used basic Template Matching technique in OpenCV to keep track
                            of the score in a cricket match from the score board and playing
                            the highlights whenever one occurs.</p>
                    </div>
                    </a>
                </div>
                <div className="col-lg-4 col-md-12 d-flex flex-column justify-content-center align-items-center project">
                    <img className="projectimg" src={project5} alt="nothing"></img>
                    <a href="https://calc007.netlify.app/" target="_blank" rel="noopener noreferrer">
                    <div className="d-flex flex-column justify-content-center align-items-center">
                        <h1>Calculator</h1>
                        <p>My first web application :), a simple calculator made with ReactJS.</p>
                    </div>
                    </a>
                </div>
            </div>
            <hr></hr>
        </div>
    )
}